export default {
	filterAsyncRouter(asyncRouterMap) { //遍历后台传来的路由字符串，转换为组件对象
		const accessedRouters = asyncRouterMap.filter(route => {
			if (route.component) {
                // route.path = route.component.replace(/^(\.)/,'').replace(/(.vue)$/,'')
				if (route.component === 'Layout') {//Layout组件特殊处理
					route.component = Layout
				}else{
					var tmp = route.component;
					// route.component = resolve => {require([`${tmp}`], resolve)}
                    route.component = () => import(`${tmp}`)
				}
			}
			if (route.children && route.children.length) {
				route.children = this.filterAsyncRouter(route.children)
			}
			return true
		})
		return accessedRouters
	},
	filterMeta(component){
		return resolve => {require([`${component}`], resolve)};
	}
}



// WEBPACK FOOTER //
// ./src/components/map.js